import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { HOTEL_CONFIG } from './base/hotel-configs';

/**
 * 호텔 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * HOTEL_CONFIG.routePath 경로로 등록.
 */
export const hotelRoutes: Routes = [
  {
    path: HOTEL_CONFIG.routePath,
    canActivate: [permissionGuard('HOTEL_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/hotel-list-page/hotel-list-page.component'
          ).then((m) => m.HotelListPageComponent),
        data: {
          config: HOTEL_CONFIG,
          title: '호텔',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/hotel-detail-page/hotel-detail-page.component'
              ).then((m) => m.HotelDetailPageComponent),
            data: {
              config: HOTEL_CONFIG,
              title: '호텔 상세',
            },
          },
        ],
      },
    ],
  },
];
